var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAudio(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "currentColor",
    strokeWidth: 3.5,
    fillOpacity: 0.4,
    fill: "#000",
    cx: 25,
    cy: 25,
    r: 23.25
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3 25.869c-.811 0-1.468.563-1.468 1.257v.702h-.022c-1.17 0-2.118.812-2.118 1.814v2.434c0 1.002.948 1.814 2.118 1.814h.022v.702c0 .694.657 1.257 1.467 1.257s1.467-.563 1.467-1.257v-7.466c0-.694-.656-1.257-1.467-1.257Zm14.89 1.959h-.022v-.702c0-.694-.657-1.257-1.467-1.257s-1.467.563-1.467 1.257v7.466c0 .694.656 1.257 1.467 1.257.81 0 1.467-.563 1.467-1.257v-.702h.022c1.17 0 2.118-.812 2.118-1.814v-2.434c0-1.002-.948-1.814-2.118-1.814Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 15.094c-5.992 0-10.85 4.94-10.85 11.032 0 .501.034.995.098 1.478a3.435 3.435 0 0 1 1.344-.864c.093-.57.392-1.099.85-1.492l.07-.057c.46-4.354 4.084-7.745 8.488-7.745s8.028 3.39 8.487 7.745l.07.057c.459.393.758.923.851 1.493a3.435 3.435 0 0 1 1.344.863c.064-.483.097-.977.097-1.478 0-6.093-4.857-11.032-10.849-11.032Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudio);
export default __webpack_public_path__ + "static/media/audio.56a0557cc6c7f119ba4594f97e392f29.svg";
export { ForwardRef as ReactComponent };